document.documentElement.classList.remove('no-js');

(() => {
  const api=window.QXTheme||{};
  const root=api.root||((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/');
  const qs=api.qs||((s,ctx=document)=>ctx.querySelector(s));
  const qsa=api.qsa||((s,ctx=document)=>[...ctx.querySelectorAll(s)]);
  const header=()=>window.QXHeaderShell||{};
  const activateDialog=(...args)=>header().activateDialog?.(...args);
  const deactivateDialog=(...args)=>header().deactivateDialog?.(...args);

/* Cart drawer */
  const cartSectionId = 'qx-cart-drawer';

  const openCart = trigger => {
    const shell = qs('[data-qx-cart-shell]');
    if (!shell) {
      window.location.href = root + 'cart';
      return;
    }

    const drawer = qs('.qx-cart-drawer', shell);

    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qx-cart-open');

    activateDialog(drawer, trigger);
    setTimeout(() => drawer?.focus(), 30);
  };

  const closeCart = (restoreFocus = true) => {
    const shell = qs('[data-qx-cart-shell]');
    if (!shell) return;

    const drawer = qs('.qx-cart-drawer', shell);

    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('qx-cart-open');

    deactivateDialog(drawer, restoreFocus);
  };
  const syncCartCount = () => {
    const shell = qs('[data-qx-cart-shell]'); if (!shell) return;
    const count = shell.dataset.cartCount || '0'; qsa('.qx-cart-count').forEach(el => el.textContent = count);
  };
  const replaceCartSection = html => {
    if (!html) return;
    const current = document.getElementById('shopify-section-' + cartSectionId);
    if (!current) return;
    const temp = document.createElement('div'); temp.innerHTML = html.trim();
    const incoming = temp.querySelector('#shopify-section-' + cartSectionId);
    if (incoming) current.replaceWith(incoming); else current.innerHTML = html;
    syncCartCount();
  };
  const cartRequest = async (endpoint, body, isFormData = false) => {
    const options = { method: 'POST', headers: { Accept: 'application/json' } };
    if (isFormData) {
      body.set('sections', cartSectionId); body.set('sections_url', location.pathname + location.search); options.body = body;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({ ...body, sections: cartSectionId, sections_url: location.pathname + location.search });
    }
    const response = await fetch(root + endpoint, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart update failed');
    replaceCartSection(data.sections?.[cartSectionId]);
    return data;
  };
  const addVariant = async (id, quantity = 1) => cartRequest('cart/add.js', { items: [{ id: Number(id), quantity: Number(quantity) }] });

  window.QXCartShell=Object.assign(window.QXCartShell||{},{
    openCart,
    closeCart,
    syncCartCount,
    replaceCartSection,
    cartRequest,
    addVariant
  });

  const boot=()=>syncCartCount();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
